import { AuthContextProvider, OidcContext } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const AveWebstreamView: FC = () => (
  <AuthContextProvider oidcContext={OidcContext.TVM}>
    <Suspense><LazyAveWebstreamView/></Suspense>
  </AuthContextProvider>
);

const LazyAveWebstreamView = lazy(importView(
  () => import("../components/AveWebstreamView"),
  (it) => it.AveWebstreamView,
));
